import { call, put, takeLatest } from 'redux-saga/effects';

import {
  receiveAPIResponse,
  requestAPIFailed,
  requestAPIHoldingData,
} from 'src/redux/api/actions';
import { apiCallAsync } from 'src/redux/api/saga';
import {
  ACR_REPORT_STATE_TRANSITION_ACTION,
  CHANGE_DATE_PICKER_ACTION,
  CHANGE_DATE_PICKER_KEY,
  POST_ACR_REPORTS_STATE_TRANSITION_KEY,
  REPORT_DETAIL_DATA_KEY,
  REPORT_LIST_DATA_KEY,
} from 'src/redux/constants';
import type { ViewAction } from 'src/redux/viewState/types';
import { getActionAPISource } from 'src/utils';

export function* changeDatePickerSaga(action: ViewAction) {
  try {
    let url = getActionAPISource(CHANGE_DATE_PICKER_KEY);
    url = url.replace(new RegExp('_id_', 'g'), action.value.reportPk);
    const response = yield call(apiCallAsync, url, action.value, 'put');

    if (response.status === 200) {
      yield put(
        requestAPIHoldingData(REPORT_LIST_DATA_KEY, null, {
          data: { period: action.value.period, dashboard_type: 'project' },
        }),
      );
    } else {
      throw 'API call has failed 5';
    }
  } catch (e) {
    yield put(requestAPIFailed(action.dataKey, e.toString()));
    console.error(e);
  }
}

export function* watchChangeDatePickerSaga() {
  yield takeLatest(CHANGE_DATE_PICKER_ACTION, changeDatePickerSaga);
}

export function* postAcrReportStateTransitionSaga(action: ViewAction) {
  try {
    let url = getActionAPISource(POST_ACR_REPORTS_STATE_TRANSITION_KEY);
    url = url.replace(new RegExp('_id_', 'g'), action.value.url_format._id_);
    const response = yield call(apiCallAsync, url, action.value.data, 'post');

    if (response.status >= 200 && response.status < 300) {
      yield put(receiveAPIResponse(action.dataKey, response.data));
      yield put(
        requestAPIHoldingData(REPORT_DETAIL_DATA_KEY, null, {
          ...action.value,
        }),
      );
    } else {
      throw 'API call has failed';
    }
  } catch (e) {
    yield put(
      requestAPIFailed(
        action.dataKey,
        e.response.data,
        Math.round(+new Date() / 1000),
      ),
    );
  }
}

export function* watchAcrReportStateTransitionSaga() {
  yield takeLatest(
    ACR_REPORT_STATE_TRANSITION_ACTION,
    postAcrReportStateTransitionSaga,
  );
}
